console.log(`js/02-components/Offers is working`);

const offersModal = document.querySelectorAll(`.offers-modal`);

if (offersModal) {
  offersModal.forEach((modal) => {
    const offerSelect = modal.querySelector(`.offer-select`);
    const offersIframeContainer = modal.querySelectorAll(
      `.offers-iframe-container`
    );

    let offersSelectNames = modal.querySelectorAll(`.offers-select-names`);
    const closeBtn = modal.querySelector(`.close`);
    offersSelectNames.forEach((offerName) => {
      offerName.addEventListener(`click`, clickedMenuItem);
      offerName.addEventListener(`click`, setOfferTitle);
    });

    const offersDropdown = modal.querySelector(`.offers-dropdown`);
    if (offersDropdown) {
      closeBtn.addEventListener(`click`, resetMenu);
    }

    function setOfferTitle() {
      let offerSelected = this.textContent;
      offerSelect.textContent = offerSelected;
    }

    function clickedMenuItem() {
      let selectedOffer = this.dataset.offerselect;
      let selectAnOffer = modal.querySelector(`.offer-location-select`);
      offersIframeContainer.forEach((offerIframe) => {
        let selectedIframe = offerIframe.dataset.offername;
        if (selectedIframe === selectedOffer) {
          offerIframe.style.display = `flex`;
        } else {
          offerIframe.style.display = `none`;
        }
      });
      selectAnOffer.style.display = `none`;
    }

    function resetMenu() {
      let textReset = modal.querySelector(`.offer-location-select`);
      let dropdownDefault = modal.querySelector(`.dropdown-toggle`);
      dropdownDefault.innerHTML = dropdownDefault.dataset.default;
      offersIframeContainer.forEach((iframes) => {
        iframes.style.display = `none`;
      });
      textReset.style.display = `block`;
    }
  });
}
